<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-08-22 17:10:30
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-08 18:13:30
-->
<template>
	<div>
		<el-drawer :title="title" :visible.sync="drawer" :wrapperClosable="false" @closed="handleClose" ref="drawer" size="754px">
			<el-form :model="form" class="mt-24 mr-24" :rules="rules" ref="departmentForm" label-width="160px">
				<el-form-item label="部门名称(必填)" prop="name">
					<el-input v-model="form.name" maxlength="10" placeholder="请填写" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="部门负责人">
					<el-select v-model="form.leaderUserId" placeholder="请选择" class="width100">
						<el-option :label="item.nickname" :value="item.id" v-for="item in nickList" :key="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="superior" prop="parentId" v-if="isShowUpDep">
					<el-select v-model="form.parentId" placeholder="请选择" class="width100" :disabled="isDisable">
						<el-option :label="item.name" :value="item.id" v-for="item in depList" :key="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="达人商务管理提成比" prop="commissionRatioDr">
					<el-input v-model="form.commissionRatioDr" placeholder="请输入提成比（0-50之间的数字）" oninput="value=value.replace(/[^0-9.]/g,'')">
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
				<el-form-item label="招商运营管理提成比" prop="commissionRatioZs">
					<el-input v-model="form.commissionRatioZs" placeholder="请输入提成比（0-50之间的数字）" oninput="value=value.replace(/[^0-9.]/g,'')">
						<template slot="append">%</template>
					</el-input>
					<div class="font-h6-medium color-gy-7 mt-8 text-align-right"> 部门负责人业绩提成不计入部门提成 </div>
				</el-form-item> -->
				<el-form-item label="备注(非必填)">
					<el-input v-model="form.remark" maxlength="50" placeholder="请填写" show-word-limit></el-input>
				</el-form-item>
			</el-form>
			<div class="demo-drawer__footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="save(form)">保存</el-button>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import { editDep, addDep, getDepName, getNickList, subEditDep } from '@/api/teamManage';
export default {
	data() {
		return {
			title: '新增部门',
			status: 0,
			drawer: false,
			direction: '',
			form: { name: '', nickame: '', leaderUserId: '', parentId: '', department: '', remark: '', commissionRatioDr: '', commissionRatioZs: '' },
			disabledSave: true,
			//新增子部门相关
			parentDepName: '', //上级部门名称（编辑部门的时候）
			parentDep: '', //上级部门
			isShowUpDep: true,
			id: 0,
			isDisable: false,
			//新增部门相关
			depList: [],
			nickList: [],
			rules: {
				name: [
					{ required: true, message: '请填写部门名称', trigger: 'blur' },
					{ min: 1, max: 10, message: '长度在 1 到 5 个字符', trigger: 'blur' },
				],
				parentId: [{ required: true, message: '请选择所属部门', trigger: 'change' }],
			},
		};
	},
	props: {
		originData: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		superior() {
			return '上级部门' + (this.status == 3 ? '(必填)' : '');
		},
		newForm() {
			return JSON.parse(JSON.stringify(this.form));
		},
	},
	methods: {
		show(val, depObj) {
			//val为1代表新增子部门，为2代表编辑部门，3为新增部门
			this.title = val == 2 ? '编辑部门' : '新增部门';
			this.status = val;
			if (val == 1) {
				this.addSonDep(depObj.id);
			} else if (val == 2) {
				this.editDep(depObj.id);
			} else {
				this.getDepPullList();
			}
			this.drawer = true;
		},
		save(form) {
			this.$refs.departmentForm.validate(valid => {
				if (valid) {
					if (this.status !== 2) {
						this.addDep(form);
					} else {
						this.subEditDep(form);
					}
				}
			});
		},
		//新增子部门val=1时
		async addSonDep(id) {
			this.form.parentId = id;
			this.getDepPullList();
			this.isDisable = true;
		},
		//编辑部门val=2时
		async editDep(id) {
			const res = await editDep(id);
			this.id = id;
			this.getDepPullList(res.name);
			this.form.parentId = `${res?.parentId}`;
			this.form.leaderUserId = res?.leaderUserId;
			if (res.parentId == 0) this.isShowUpDep = false;
			this.form.name = res?.name;
			this.form.remark = res?.remark;
		},
		//新增部门val=3时
		async addDep(form) {
			await addDep(form);
			this.$emit('refresh');
			this.drawer = false;
		},
		//编辑部门后提交
		async subEditDep(form) {
			let subform = {
				...form,
				id: this.id,
			};
			await subEditDep(subform);
			this.$message.success('操作成功！');
			this.$emit('refresh');
			this.drawer = false;
		},
		//新增部门中获取下拉列表
		async getDepPullList(val) {
			this.nickList = await getNickList();
			this.nickList = this.nickList.filter(item => item.id == this.form.leaderUserId || (item.deleted == 0 && item.useStatus == 1));
			this.depList = await getDepName();
			if (val) this.depList = this.depList.filter(item => item.name != val);
		},
		handleClose() {
			this.drawer = false;
			this.isShowUpDep = true;
			this.isDisable = false;
			this.form = { name: '', nickame: '', leaderUserId: '', parentId: '', department: '', remark: '', commissionRatioDr: '', commissionRatioZs: '' };
			this.$refs.departmentForm.resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-form-item__label {
	padding-right: 8px;
}
.demo-drawer__footer {
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	position: absolute;
	bottom: 0px;
	width: 100%;
	height: 64px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	&/deep/.el-button + .el-button {
		margin-right: 15px !important;
		margin-left: 16px !important;
		width: 88px;
	}
	&/deep/:first-child {
		width: 76px !important;
	}
}
</style>
